<template>
  <div v-show="show">
    <div class="modal-backdrop" @click="onBlur"></div>
    <div class="modal-dialog" >
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      hideOnBlur: Boolean
    },
    watch: {
      show (val) {
        this.$emit(val ? 'onShow' : 'onHide')
      }
    },
    methods: {
      onBlur (ev) {
        if (this.hideOnBlur) {
          this.$emit('close-modal')
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../common/css/mixmin'

  .consultant-dialog
    .modal-backdrop
      z-index 1000
      overflow hidden
      background-color: rgba(33,34,40,0.6)!important
    .modal-content
      position absolute
      top 50%
      left 50%
      width px2rem(532)!important
      height px2rem(664)
      background-color #fff
      border-radius 5px
      transform translate(-50%, -50%)
      -webkit-transform translate(-50%, -50%)
      box-shadow 0 0 px2rem(57) 0 rgba(20,28,35,1, .75)
    .modal-dialog
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      -webkit-transform translate(-50%, -50%)
      width px2rem(532)!important
      height px2rem(664)
    .page-caption
      margin-top px2rem(30)
      .title
        margin 0
        color #234D73
        font-size px2rem(28)
        text-align center
        margin-left px2rem(70)
        .iconfont
          display inline-block
          width px2rem(44)
          height px2rem(44)
          color #e5e5e5
          margin-right px2rem(20)
      .point
        height px2rem(5)
        width px2rem(22)
        background-color #4ED1FF
        border-radius px2rem(3)
        margin 0 auto
        margin-top px2rem(16)
  .line
    height 1px
    margin-top px2rem(18)
    background-color #f0f2f3
  .clearfix:after
    content '.'
    display block
    clear both
    height 0
    overflow hidden
  .appointment-wrap
    .common-style
      height px2rem(98)
      font-size px2rem(24)
      color #234D73
      line-height px2rem(98)
      border-bottom 1px solid #f0f2f3
      .common-padding
        padding-left px2rem(36)
      .pull-right
        padding-right px2rem(41)
        width 65%
        .time-wrap
          width px2rem(115)
        .time
          width 100%
        .septal-line
          width px2rem(26)
          height px2rem(3)
          background-color rgba(#224A6C .4)
          margin-top px2rem(48)
        .iconfont
          width px2rem(10)
          height px2rem(10)
          color #4ED1FF
          float right
    input
      border none
      -webkit-appearance: none
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0)

    .confirm-btn
      margin px2rem(30) px2rem(36) px2rem(30) px2rem(36)
      button
        width px2rem(472)
        height px2rem(70)
        background-color #4ED1FF
        border none
        font-size px2rem(26)
        color white
        border-radius px2rem(4)
</style>



// WEBPACK FOOTER //
// modal2.vue?49824ac0